<template>
  <el-card class="h-100 position-absolute" id="cableList">
    <!-- 表头 -->
    <div slot="header">
      <el-row type="flex" align="middle">
        <el-col :span="18">{{ trayCode }}</el-col>
        <el-col :span="6" class="tr">
          <el-tooltip :content="'关闭电缆列表'" :open-delay="1000">
            <span class="iconfont icon-close" style="cursor: pointer;" @click="closeCard"></span>
          </el-tooltip>
        </el-col>
      </el-row>
    </div>
    <!-- 电缆列表 -->
    <div
      class="h-90 w-100"
      style="overflow: auto; margin-bottom: 5px; border-bottom: 1px solid #DCDFE6"
    >
      <ul class="tray-list">
        <template v-for="(item, index) in cableTray">
          <li
            :key="item.id"
            @click="showOneCableTray(item, index)"
            :class="[activeTray === index ? 'active-li' : 'no-active']"
          >
            {{ item.cableCode }}
          </li>
        </template>
      </ul>
    </div>
    <!-- 操作 -->
    <div class="w-100 tc h-10">
      <el-button
        size="small"
        type="primary"
        @click="clickAllCable('show')"
        :disabled="!cableTray.length"
        >显示全部电缆</el-button
      >
      <el-button
        size="small"
        type="primary"
        @click="clickAllCable('clear')"
        :disabled="!cableTray.length"
        >清除显示电缆</el-button
      >
    </div>
  </el-card>
</template>
<script>
import ApiMixinCable from '@/assets/js/api/cableManagement'

export default {
  mixins: [ApiMixinCable],
  data() {
    return {
      activeTray: '',
      cableList: [], // 电缆列表
      trayCode: '',
      cableTray: [],
    }
  },
  watch: {
    async trayCode() {
      this.cableTray = await this.getCableTray()
    },
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  methods: {
    // 点击桥架，获取所有电缆
    async getCableTray() {
      const res = await this.apiCable({
        method: 'findByCabletray',
        params: {
          siteId: this.currentProject.id,
          code: this.trayCode,
        },
      })
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 点击桥架上的电缆显示
    showOneCableTray(data, index) {
      this.$emit('moveCamera', data.cableCode)
    },
    // 关闭桥架卡片
    closeCard() {
      this.$emit('closeTray')
    },
    // 点击显示全部或者清空全部
    clickAllCable(type) {
      if (this.cableTray.length) {
        this.activeTray = ''
        this.clearTrayCable()
        if (type === 'show') {
          this.cableTray.forEach((item, index) => {
            // this.drawAllTray[index] = this.player.generateCable(
            //   this.modelRow.md5,
            //   item.cableCode,
            //   this.cableRadius,
            //   0xffda1c1c
            // )
            // this.player.addCable(this.drawAllTray[index])
            // this.player.drawNextFrame()
            this.$emit('startDrawLine', item)
          })
        }
      }
    },
    // 清除桥架上的电缆
    clearTrayCable() {
      this.$emit('checkMarked')
      // if (this.drawAllTray.length) {
      //   this.drawAllTray.forEach((item) => {
      //     this.player.removeCable(item)
      //     this.player.drawNextFrame()
      //     this.drawAllTray = []
      //   })
      // }
      // if (this.drawOneTray) {
      //   this.player.removeCable(this.drawOneTray)
      //   this.player.drawNextFrame()
      //   this.drawOneTray = null
      // }
    },
  },
}
</script>
<style lang="scss" scoped>

#cableList {
  height: 400px;
  width: 350px;
  right: 20px;
  bottom: 30px;
  box-shadow: 0px 0px 1px 4px #dcdbdb91;
  border-radius: 4px;
  z-index: 998;
}
.h-90 {
  height: 90%;
}
.h-10 {
  height: 10%;
}
.tray-list {
  padding: 10px 0;
  li {
    text-indent: 20px;
    padding: 4px;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      background-color: #dcdfe6;
    }
  }
  .no-active {
    background-color: transparent;
  }
  .active-li {
    background-color: #dcdfe6;
  }
}
/deep/.el-card__header {
  height: 10%;
  background: #fff;
}
/deep/.el-card__body {
  height: 90%;
  background-image: url('/css/white/bg.png');
  background-position: 88%;
}

</style>
